const telegraRoutes = [
	{
		path: '/telegra',
		name: 'telegra',
		component: () => import(/* webpackChunkName: "telegra" */ '@/modules/Telegra/TelegraView.vue'),
		meta: {
			hideHeader: true,
			skipExperiments: true,
			// Screen-view events for the intake are emitted per question inside
			// TelegraView (OnboardingStepShow) — no route-level analytics meta needed.
			// The intake is pre-auth since DEV-34805 (session-scoped API) — nothing to gate on.
		},
	},
]

export default telegraRoutes
